import Vue from "vue";

export function uppercaseFirst(str) {
  return str[0].toUpperCase() + str.substring(1);
}

Vue.filter('ucFirst', uppercaseFirst)
